import { takeLatest } from "redux-saga/effects";
import {
	getAssetListSuccess,
	getAssetListFail,
	getAssetDetailsSuccess,
	getAssetDetailsFail,
} from "./assetState";
import createCrudService from "../../services/crudservice";
import {
	doCrudCall,
	SAVING_MSG,
	UPDATING_MSG,
	DELETING_MSG,
	LOADING_MSG,
	createRecordSuccess,
	updateRecordSuccess,
	deleteRecordSuccess,
} from "../../utils/crudSagaHelper";

const crudService = createCrudService("api/v1/system/assets");
const redirectData = { route: "/console/asset-managements", mode: "list", recordId: 0 };
const modelName = "Asset";
const modelId = "ast_id";

function* getAssetList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload),
		getAssetListSuccess,
		getAssetListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getAssetDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload),
		getAssetDetailsSuccess,
		getAssetDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doAssetCreate(data) {
	yield doCrudCall(
		() => crudService.doCreate(data.payload),
		getAssetDetailsSuccess,
		getAssetDetailsFail,
		createRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		SAVING_MSG
	);
}

function* doAssetUpdate(data) {
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload),
		getAssetDetailsSuccess,
		getAssetDetailsFail,
		updateRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		UPDATING_MSG
	);
}

function* doAssetDelete(data) {
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId),
		getAssetDetailsSuccess,
		getAssetDetailsFail,
		deleteRecordSuccess(modelName),
		{ ...redirectData, mode: data.payload.mode },
		DELETING_MSG
	);
}

function* assetSaga() {
	yield takeLatest("asset/getAssetList", getAssetList);
	yield takeLatest("asset/getAssetDetails", getAssetDetails);
	yield takeLatest("asset/doAssetCreate", doAssetCreate);
	yield takeLatest("asset/doAssetUpdate", doAssetUpdate);
	yield takeLatest("asset/doAssetDelete", doAssetDelete);
}

export default assetSaga;